import React from 'react'
import PropTypes from 'prop-types'
import Alert from '@mui/material/Alert'
import './SplashScreen.scss'
import { useSelector } from 'react-redux'

export default function AmenitiesInfoAlert() {
  const { amenitiesNotSeenOnStreetmix } = useSelector((state) => state.appSlice)
  return (
    <Alert
      severity="info"
      sx={{
        mb: 2,
        width: amenitiesNotSeenOnStreetmix.length > 3 ? '40vw' : '35vw',
        position: 'absolute',
        top: 130,
        left: '35%',
        zIndex: 1050,
        '& .MuiAlert-message': {
          alignSelf: 'center'
        }
      }}
      className="width-alert"
    >
      Amenities such as{' '}
      <strong>{amenitiesNotSeenOnStreetmix.join(', ')}</strong> are added to
      your streetmix but not visible in your cross section.
    </Alert>
  )
}
AmenitiesInfoAlert.propTypes = {}
